// extracted by mini-css-extract-plugin
export default {"div1":"dashboard_div1__w9GO4","p1":"dashboard_p1__lxp0d","div2":"dashboard_div2__ylkgx"};